import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function Error400Page() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-center p-6">
      <h1 className="text-4xl font-bold mb-4">400 - Bad Request</h1>
      <p className="text-muted-foreground mb-8">
        Oops! The request could not be processed. Please check your input or try again later.
      </p>
      <div className="flex space-x-4">
        <Button
          variant="primary"
          onClick={() => navigate('/')}
          className="px-6 py-2"
        >
          Go to Home
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="px-6 py-2"
        >
          Go Back
        </Button>
      </div>
    </div>
  );
}
